module.exports = __webpack_public_path__ + "img/tushi3.153087a5.jpg";